module.exports = __webpack_public_path__ + "static/media/logo.38ec89ae.png";